/** Created by azhou on 2019/3/25.*/
<template>
  <div>
    <!--采购商-->
    <div  v-if="storeType == 2">
      <el-collapse accordion>
        <el-collapse-item v-for="(item,index) in info" :key="index">
          <template slot="title">
            <ul  class="list-item w-100">
            <li class="w-30 list-item-col  fomf-left">
              <span class="text-link ml-4" @click="$emit('goStoreDetail',item.id)">{{item.title| formatString(18)}}</span>
              <el-popover placement="right" trigger="hover">
                <div>
                    <span :class="[item.verify==1?'text-success':'text-danger']">{{item.verify==1?'已认证':'未认证'}} </span>
                </div>
                <i class=" text-link male" :class="[item.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference" v-if="item.title!='无'"></i>
              </el-popover>
            </li>
            <li class="w-20 list-item-col"><span v-if="item.user_list.length>0">{{item.user_list[0].username||'无'}}</span></li>
            <li class="w-15 list-item-col">{{item.user_count||'0'}}</li>
            <li class="w-15 list-item-col">
              {{ item.travel_tel }}
            </li>
            <li  class="w-20 list-item-col">{{item.province| obtainProvince()}} {{item.city| obtainProvince()}} {{item.district| obtainProvince()}}</li>
            <!-- <li class="w-10 list-item-col">{{item.score}}</li> -->
            <li class="w-10 list-item-col" :class="[item.display===1?'text-success':'text-danger']">
              {{item.display?'已显示':'未显示'}}
            </li>
            <!-- <li class="w-10 list-item-col" :class="[item.contract>0?'text-success':'text-danger']" v-if="storeType!==2">
              {{item.contract>0?'已签约':'未签约'}}
            </li> -->
            <!-- <li class="w-20 list-item-col-end">
              <span class="text-link" @click="$emit('editStore',item.id)">编辑</span>
            </li> -->
          </ul>
          </template>
          <!--旗下人员-->
          <div class="sulies">旗下采购</div>
          <div class="w-100 subsidiary" v-if="item.user_list.length>1">
            <template v-for="(v,ind) in item.user_list">
              <div :key="ind" class="subsidiary-sales"   v-if="ind>0">
                <el-popover placement="right" trigger="hover" v-if="v.level!==2">
                  <div>
                    <span :class="[openid(v)?'text-danger':'text-success']">{{openid(v)?'未绑定':'已绑定'}} </span>
                  </div>
                  <i class="iconfont icon-weixin1" :class="[v.wechat_openid!=v.uid ? 'text-success' : 'text-muted']" slot="reference"></i>
                </el-popover>
                <span class="ml-3">{{v.truename}}</span>
                <span class="ml-3">{{v.level| formatVar('userLevel')}}{{ v.level==2?'账户':'' }}</span>
                <span class="ml-3">电话：{{v.mobile}}</span>
                <div class="mr">
                  <el-dropdown @command="handleCommand($event,v,item)">
                    <el-button type="primary">
                      操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">查看账户</el-dropdown-item>
                      <el-dropdown-item command="2">解除关联</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <!-- <el-button class="mr" type="primary" @click="checkDetail(v)" size="mini">查看账户</el-button>
                <el-button class="mr" type="primary" @click="checkDetail(v)" size="mini">解除关联</el-button> -->
              </div>
            </template>  
          </div>
          <div class="w-100 list-item-list" v-else>暂无人员</div>
          <div class="sulies border-none">企业操作</div>
          <div class="mt-1 mr">
            <el-button @click="checkDetail(item.user_list[0])" v-if="item.user_list.length>0">企业信息</el-button>
            <el-button @click="createStoreUsername(item)" v-else>创建企业账号</el-button>
            <el-button class=""  @click="$emit('editStore',item.id)" >编辑企业</el-button>
            <el-button class="mr-2"  @click="addUser=true,addUseItem=item" >添加销售</el-button>
            <el-button class="mr-2"  @click="addPosition(item)" >邀请二维码</el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!--酒店-->
    <div  v-if="storeType == 3">
      <el-collapse accordion>
        <el-collapse-item v-for="(item,index) in info" :key="index">
          <template slot="title">
            <ul  class="list-item w-100" >
            <li class="w-30 list-item-col  fomf-left">
              <span class="text-link ml-4" @click="$emit('goStoreDetail',item.id)">{{item.title| formatString(18)}}</span>
              <el-popover placement="right" trigger="hover">
                <div>
                    <span :class="[item.verify==1?'text-success':'text-danger']">{{item.verify==1?'已认证':'未认证'}} </span>
                </div>
                <i class=" text-link male" :class="[item.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference" v-if="item.title!='无'"></i>
              </el-popover>
            </li>
             <li  class="w-10 list-item-col">{{item.room_count||'0'}}</li>
              <li  class="w-10 list-item-col">{{item.room_2_count||'0'}}</li> 
            <li  class="w-10 list-item-col" ><span v-if="item.user_list.length>0">{{item.user_list[0].username||'无'}}</span></li>
            <li  class="w-10 list-item-col">{{item.user_count||'0'}}</li>
            
            <li  class="w-10 list-item-col ">{{item.star | formatVar('HotelStar')}}</li>
            <li class="w-15 list-item-list">
              <div class="name-wrapper">
                {{item.hotel_tel[0]}}
                <el-popover trigger="hover" placement="top">
                <p v-for="(value,ins) in item.hotel_tel" :key="ins">总机：{{value}}</p>
                <div slot="reference" class="icon-more" v-if="item.hotel_tel.length>1">
                  <i class="el-icon-more" ></i>
                </div>
              </el-popover>
              </div>
            </li>
            <li  class="w-15 list-item-col address">{{item.province| obtainProvince()}} {{item.city| obtainProvince()}} {{item.district| obtainProvince()}}</li>
            <li  class="w-10 list-item-col">{{item.exp}}</li>
            <li  class="w-10 list-item-col" :class="[item.display===1?'text-success':'text-danger']">
              {{item.display?'已显示':'未显示'}}
            </li>
            <!-- <li class="w-20 list-item-col-end">
              <span class="text-link" @click="$emit('editStore',item.id)">编辑</span>
            </li> -->
          </ul>
          </template>
          <!--旗下人员-->
          <div class="sulies">旗下销售</div>
          <div class="w-100 subsidiary" v-if="item.user_list.length>1">
            <template v-for="(v,ind) in item.user_list">
            <div   :key="ind" class="subsidiary-sales"  v-if="ind>0">
              <el-popover placement="right" trigger="hover" class="mt-2">
                <div>
                  <span :class="[openid(v)?'text-danger':'text-success']">{{openid(v)?'未绑定':'已绑定'}} </span>
                </div>
                <i class="iconfont icon-weixin1 mt-1" :class="[v.wechat_openid!=v.uid ? 'text-success' : 'text-muted']" slot="reference"></i>
              </el-popover>
              <span class="ml-3">{{v.truename}}</span>
              <span class="ml-3">{{v.level| formatVar('userLevel')}}</span>
              <span class="ml-3">电话：{{v.mobile}}</span>
              <div class="mr">
                <el-dropdown @command="handleCommand($event,v,item)">
                  <el-button type="primary">
                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">查看账户</el-dropdown-item>
                    <el-dropdown-item command="2">解除关联</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <!-- <el-button class="mr" type="primary" @click="checkDetail(v)" size="mini">查看账户</el-button> -->
            </div>
            </template>  
          </div>
          <div class="w-100 list-item-list" v-else>暂无人员</div>
          <div class="sulies border-none">酒店操作</div>
          <div class="mt-1">
            <el-button @click="checkDetail(item.user_list[0])" v-if="item.user_list.length>0">企业信息</el-button>
            <el-button @click="createStoreUsername(item)" v-else>创建企业账号</el-button>
            <el-button @click="$emit('editStore',item.id)" >编辑企业</el-button>
            <el-button class="mr-2"  @click="addUser=true,addUseItem=item" >添加销售</el-button>
            <el-button class="mr-2"  @click="addPosition(item)" >邀请二维码</el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!--邀请二维码弹框-->
    <el-dialog :title="backgroundtext" :visible.sync="QRcodeShwo" width="600px" center id="loadConfirm"  top="36vh">
        <img :src="backgroundImage" alt="二维码" class="remove-margin" v-if="backgroundImage"/>
        <div class="formbuttton">
          复制二维码分享邀请人员、微信扫码并进行加入{{storeType == 2?'企业':'酒店销售'}}!
        </div>
    </el-dialog>
    <!--创建企业账号弹框-->
    <el-dialog :title="'创建企业账号'" :visible.sync="createAccount" width="600px" center id="loadConfirm"  top="36vh">
        <!--表单错误提示-->
        <div class="form-data">
          <div class="d-cent-name"><left-text leftText="酒店名称" type="number"/>{{ hoteTitle }}</div>
          <left-text-border leftText="联系人" type="text" class="w-100 mt-3"   v-model="formData.contact" @blur="validateFun(1)"/>
          <div class="d-cent-name mt-1" v-if="rules.contact.required"><left-text leftText="" type="number"/><span class="corls">{{ rules.contact.message}}</span></div>
          <left-text-border leftText="手机号" type="number" class="w-100 mt-3" v-model="formData.mob" @blur="validateFun(0)"/>
          <div class="d-cent-name mt-1" v-if="rules.mob.required"><left-text leftText="" type="number"/><span class="corls">{{ rules.mob.message}}</span></div>
        </div>
        <div  class="d-cent-name comt mt-4">
          <el-button @click="createAccount = false">取消</el-button>
          <el-button type="primary" @click="createStoreUsername()">确认创建</el-button>
        </div>
    </el-dialog>
    <!--添加人员弹框-->
    <el-dialog :title="'添加销售'" :visible.sync="addUser" width="400px" center id="loadConfirm"  top="32vh">
      <AddPersonnel :addUseItem="addUseItem" :storeType="storeType" @addSuccess="addSuccess"></AddPersonnel>
    </el-dialog>
    <!--企业用户详情-->
    <el-dialog title="账户详情" :visible.sync="showDetail" center :show-close="false">
      <div class="d-flex flex-wrap">
        <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
          <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
        </div>
        <div class="d-center-start w-50 mb-3" v-if="currentItem.level=='企业'">
          <left-text leftText="门店账号"/>
          <span class="mr-2">{{currentItem.username}}</span>
        </div>
        <div class="d-center-start w-50 mb-3">
          <left-text leftText="账号密码"/>
          <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
          <i class="iconfont text-link" @click="showPassword = !showPassword"
              :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
        </div>
      </div>
      <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState,mapGetters,mapActions} from 'vuex'
  import AddPersonnel from './Components/AddPersonnel.vue'
  export default {
    name: 'StoreLists',
    components: {AddPersonnel},
    data() {
      return {
        showPassword:false,
        showDetail:false,
        showDetailArr:[
          {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户级别',value:'level'},
          {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
          {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'}
        ],
        currentItem:{},
        QRcodeShwo:false,
        backgroundImage:'',
        backgroundtext:'',
        createAccount:false,           //企业账号开关
        hoteTitle:'',                  //酒店名称
        formData:{
          contact:'',                 //联系人
          mob:'',                     //手机号
          store_id:'',                //门店ID
          store_type:''               //门店类型
        },
        rules:{
          contact:{ required: false, message: '请填写联系人'},
          mob:{ required: false, message: '请填写正确的手机号'},
        },
        addUser:false,           //添加人员开关
        addUseItem:{},              //添加人员当前酒店
      }
    },
    props:{
      info:{
        type:Array,
        default:[]
      }
    },
    computed: {
      ...mapState(['userLoginMessage','AdminDataDetail']),
      ...mapGetters(['storeInfo']),
      storeType() { return Number(this.$route.query.storeType) },
    },
    methods: {
    ...mapActions(['getItemDetail','POST_GetInviteUnionQRCode','POST_UnionRemove','POST_Admin_CreateStoreUsername']),
     openid(data){
        return data.wechat_openid==''||data.uid==data.wechat_openid
      },
      //用户详情情页
      async checkDetail(item) {
        await this.getItemDetail({
          type:'userDetail',
          data:{
            uid:item.uid,
            // store_type:item.type
          }
        })
        this.currentItem = {
          ...this.AdminDataDetail,
          wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
          level:this.$options.filters['formatVar'](item.level,'userLevel'),
          trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
          login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
          reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
        };
        this.showDetail = true;
      },
      //生成门店邀请二维码
      addPosition(item){
        this.backgroundImage='';
        this.POST_GetInviteUnionQRCode({
          data: {store_id:item.id,store_type:this.storeType},
          successFun: (res) => {
            this.QRcodeShwo = true;
            this.backgroundtext=item.title;
            this.backgroundImage = 'data:image/jpeg;base64,'+res.qr_code;
          },
        });
      },
      //创建门店企业账号
      createStoreUsername(item){
        /******开启创建弹窗*******/
        if(!this.createAccount){
          this.createAccount = true;
          this.formData.store_id = item.id;
          this.formData.store_type = this.storeType;
          this.hoteTitle=item.title;
        /******发送请求*******/
        }else{
          //验证表单
          let result=this.validateFun(0);
          if (result.code) {
            this.POST_Admin_CreateStoreUsername({
              data:this.formData,
              successFun: () => {
                this.createAccount = false;
                this.$emit('getDataLists');
              },
            })
          }
        }
      },
      //添加人员成功
      addSuccess(){
        this.$emit('getDataLists');
        this.addUser = false;
      },
      /*表单验证函数*/
      validateFun(validateType = 0) {
        const { formData = {}, rules } = this;
        // 验证联系人
        rules.contact.required = !formData.contact;
        if (rules.contact.required) return {};
        // 验证手机号（仅validateType=0时）
        if (validateType === 0) {
          rules.mob.required = !this.$GFUN.isPhone(formData.mob);
          if (rules.mob.required) return {};
        }
        return { code: true };
      },
      //点击操作按钮
      handleCommand(command,v,item) {
        let htis = this;
        switch (command) {
          case '1':
            htis.checkDetail(v)
            break
          case '2':
            this.deleteItem(v,item)
            break
          case '3':
            break
        }
      },
      //解除关联
      deleteItem(v,item) {
        this.POST_UnionRemove({data: {uid:v.uid,store_id:item.id,store_type:this.storeType},
            successFun: () => {
              this.$emit('getDataLists');
            },
        });
      },
    },
  }
</script>
<style scoped>
  .sulies{
    border-top: 1px #eee solid;
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    padding-top: 12px;
  }
  .male{
    margin-left: 4px;
    margin-top: 4px;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
  }
  .w96{
    width: 96%;
    margin: 0 auto;
  }
  .list-item-col,.list-item-list, .list-item-col-end{
    line-height: 48px !important;
    min-height: 48px;
    padding: 0;
  }
  .list-item-list div{
    line-height: 48px;
  }
  .fomf-left{
    display: flex;
    justify-content: left;

  }
  .list-item{
    border-bottom: none;
  }
  .list-item-col, .list-item-col-end{
    border-right: 1px solid #EBEEF5;
    
  }
  .list-item li:last-child{
   border-right:none;
  }
  .subsidiary{
    
    display: flex;
    flex-wrap: wrap;
        justify-content: center;
  }
  .subsidiary-sales{
    width: calc(30% - 30px);
    margin-right: 30px;
    /* border: 1px solid #bfcde2; */
    background-color: #f5f7fa;
    margin-top: 12px;
    border-radius: 4px;
    padding: 6px 1%;
    text-align: left;
    display: flex;

  }
  .subsidiary-sales span{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .mr{
    margin-left: auto;
  }
  .subsidiary div:nth-child(3n) {
    margin-right: 0;
  }
  .border-none{
    border-top: none;
  }
  .formbuttton{
  display: flex;
  justify-content: center;
  }
  .remove-margin{
    margin: 0 auto;
    display: block;
    margin-bottom: 20px;
  }
  .name-wrapper{
    text-align: center;
    margin:  auto;
    display: block;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
  }
  .icon-more{
    font-size: 12px;
    line-height: normal !important;
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform:translate(-50%,-50%);
  }
  .form-data{
    width: 70%;
    margin: 0 auto;
  }
  .d-cent-name{
    display:flex;
  }
  .comt{
    justify-content: center;
  }
  .corls{
    color:red;
    font-size: 12px;  
  }
  .address{
    line-height:normal !important;
  }
</style>